<template>
  <a-image-preview-group :class="`${bem.b()}`" v-bind="props">
    <slot />
  </a-image-preview-group>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { imageProps as imagePreviewGroupProps } from './image'

defineOptions({
  name: 'LlImagePreviewGroup'
})

const props = defineProps(imagePreviewGroupProps)

const bem = createNamespace('image-preview-group')
</script>
